import React from 'react'
import { Button } from 'react-bootstrap'
import ElementWithTooltip from '@/components/shared/ElementWithTooltip'

interface Props {
  allExpanded: boolean
  onToggle: () => void
  singularLabel: string
  className?: string
}

export default function AccordionToggleAllButton({
  allExpanded,
  onToggle,
  singularLabel,
  className,
}: Props) {
  const tooltip = allExpanded ? `Collapse all ${singularLabel}` : `Expand all ${singularLabel}`

  return (
    <ElementWithTooltip tooltip={tooltip} placement="top">
      <Button
        variant="primary"
        className={className}
        onClick={onToggle}
        aria-label={tooltip}
      >
        <i className={`fas ${allExpanded ? 'fa-compress-alt' : 'fa-expand-alt'}`} />
      </Button>
    </ElementWithTooltip>
  )
}
